import React from "react";
import { Helmet } from "react-helmet-async";
import PropTypes from "prop-types";

function SEO({
  title = "Gestoría en Granada | Asesoría Fiscal, Laboral y Contable — Gestoría Moreno",
  description = "Gestoría Moreno en Granada: Especialistas en asesoría fiscal, laboral, contable y gestión administrativa. Más de 60 años de experiencia profesional. Consulta sin compromiso.",
  keywords = "gestoria granada, asesoria fiscal granada, asesoria laboral granada, asesoria contable granada, gestoria moreno, impuestos granada, nominas granada, contabilidad granada",
  canonicalUrl,
  ogImage = "/logo.png",
  ogType = "website",
  robots = "index, follow",
  schemaData,
}) {
  const baseUrl = "https://gestoriamoreno.com";
  const fullCanonicalUrl = canonicalUrl ? `${baseUrl}${canonicalUrl}` : `${baseUrl}/`;
  const fullOgImage = ogImage.startsWith("http") ? ogImage : `${baseUrl}${ogImage}`;

  return (
    <Helmet>
      {/* Título y meta descripción */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content={robots} />

      {/* URL canónica */}
      <link rel="canonical" href={fullCanonicalUrl} />

      {/* Open Graph para redes sociales */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullOgImage} />
      <meta property="og:url" content={fullCanonicalUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="Gestoría Moreno Granada" />
      <meta property="og:locale" content="es_ES" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullOgImage} />

      {/* Meta adicionales para SEO local */}
      <meta name="geo.region" content="ES-AN" />
      <meta name="geo.placename" content="Granada" />
      <meta name="geo.position" content="37.1773;-3.5986" />
      <meta name="ICBM" content="37.1773, -3.5986" />

      {/* Language alternate */}
      <link rel="alternate" hrefLang="es" href={fullCanonicalUrl} />
      <link rel="alternate" hrefLang="x-default" href={fullCanonicalUrl} />

      {/* Schema.org JSON-LD */}
      {schemaData && <script type="application/ld+json">{JSON.stringify(schemaData)}</script>}
    </Helmet>
  );
}

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  canonicalUrl: PropTypes.string,
  ogImage: PropTypes.string,
  ogType: PropTypes.string,
  robots: PropTypes.string,
  schemaData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default SEO;
